// Google Analytics utility functions
// Provides type-safe methods for tracking events and page views

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        dataLayer: any[];
    }
}

// Initialize Google Analytics
export const initGA = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', 'G-GMV4NTSBRN', {
            page_title: document.title,
            page_location: window.location.href,
        });
    }
};

// Track page views
export const trackPageView = (url: string, title?: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', 'G-GMV4NTSBRN', {
            page_path: url,
            page_title: title || document.title,
            page_location: window.location.href,
        });
    }
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location?: string) => {
    trackEvent('click', 'button', `${buttonName}${location ? ` - ${location}` : ''}`);
};

// Track form submissions
export const trackFormSubmission = (formName: string) => {
    trackEvent('submit', 'form', formName);
};

// Track video interactions
export const trackVideoPlay = (videoTitle: string) => {
    trackEvent('play', 'video', videoTitle);
};

// Track navigation events
export const trackNavigation = (destination: string, source?: string) => {
    trackEvent('navigate', 'navigation', `${source || 'unknown'} → ${destination}`);
};

// Track service interactions
export const trackServiceView = (serviceName: string) => {
    trackEvent('view', 'service', serviceName);
};

// Track demo requests
export const trackDemoRequest = (source: string) => {
    trackEvent('demo_request', 'conversion', source);
};

// Track external link clicks
export const trackExternalLink = (url: string, linkText?: string) => {
    trackEvent('click', 'external_link', linkText || url, undefined);
};

// Track scroll depth
export const trackScrollDepth = (depth: number) => {
    trackEvent('scroll', 'engagement', `${depth}%`);
};

// Track time on page
export const trackTimeOnPage = (timeInSeconds: number) => {
    trackEvent('timing', 'engagement', 'time_on_page', timeInSeconds);
};
